import React, { useState, useEffect } from "react";
import Base from "../Employee_components/Employee_Base";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Button } from "react-bootstrap";
import { Breadcrumbs, Link, TextField } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "../Employee Section/EmployeeList.css";
import UseAxios from "../Auth/UseAxios";
import { EMPLOYEE_API_BASE_URL } from "../Auth/Api";
import { useAuth } from "../Auth/AuthContext";
import { ClipLoader } from "react-spinners";

const EmployeeList = () => {
  const [employeeList, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [filterStatus, setFilterStatus] = useState("All");
  const [searchTerm, setSearchTerm] = useState(""); // State for filtering by name
  const api = UseAxios();
  const { employee } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);



  useEffect(() => {
    const fetchEmployeeList = async () => {
      try {
        const response = await api.get(`${EMPLOYEE_API_BASE_URL}/employee/hierarchy/${employee.employeeReferenceId}`);
        setList(response.data);
      } catch (error) {
        setError("Error fetching employees");
      } finally {
        setLoading(false);
      }
    };
    fetchEmployeeList();
  }, [api, employee.employeeReferenceId]);

  // Filter Employees Based on Status and Name
  const filteredEmployees = employeeList
    .filter((emp) => filterStatus === "All" || emp.status === filterStatus)
    .filter((emp) => emp.fullName.toLowerCase().includes(searchTerm.toLowerCase()));

  // Pagination
  const paginatedEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterStatus, searchTerm]);


  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div
            className="pt-3 mt-5"
            style={{ display: "flex", justifyContent: "flex-end", paddingRight: "20px" }}
          >
            {/* Breadcrumbs */}
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" href="/employee/dashboard" sx={{ color: "blue", fontWeight: "bold" }}>
                Dashboard
              </Link>
              <Link underline="none" color="inherit" href="/employee/employee_list" sx={{ color: "darkslategrey", fontWeight: "bold" }}>
                Employee List
              </Link>
            </Breadcrumbs>
          </div>



          <h2 className="text-center fw-bold fs-1" style={{ color: "darkslategrey" }}>Employee List</h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "80%" }} />
          </div>

          <div className="mt-2  p-2 float-end employee-filter">
            <TextField
              label="Search by Name"
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "darkslategrey" }, // Normal state
                  "&:hover fieldset": { borderColor: "black" }, // Hover state
                  "&.Mui-focused fieldset": { borderColor: "black" }, // Focused state
                },
              }}

            />
          </div>


          <div className="container mt-1 emp-list">
            {/* Employee Table */}
            <Table className="employee-list">
              <Thead>
                <Tr>
                  <Th>Sno</Th>
                  <Th>Employee ID</Th>
                  <Th>Employee Name</Th>
                  <Th>Designation</Th>
                  <Th>Mobile Number</Th>
                  <Th>Status</Th>
                  <Th>Actions</Th>
                </Tr>
              </Thead>
              <Tbody>
                {paginatedEmployees.length > 0 ? (
                  paginatedEmployees.map((employee, index) => (
                    <Tr key={employee.id}>
                      <Td>{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                      <Td>{employee.employeeReferenceId}</Td>
                      <Td>{employee.fullName}</Td>
                      <Td>{employee.designation}</Td>
                      <Td>{employee.mobile}</Td>
                      <Td style={{ color: employee.active ? "green" : "red" }}>
                        {employee.active ? "Active" : "InActive"}
                      </Td>
                      <Td className="listbutton" style={{ display: "flex", gap: "5px" }}>
                        <Link href={`/employee/edit_employee/${employee.employeeReferenceId}`}>
                          <Button className="btn-sm">Edit</Button>
                        </Link>
                        <Link href={`/employee/view_employee/${employee.employeeReferenceId}`}>
                          <Button className="btn-sm">View</Button>
                        </Link>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan="7" className="text-center">
                      No employees found.
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>

            {/* Pagination Controls */}
            <div className="pages-controls">
              <Button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                Previous
              </Button>
              <span className="mx-2">Page {currentPage} of {totalPages}</span>
              <Button onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages}>
                Next
              </Button>
            </div>
          </div>
        </>
      )}
    </Base>
  );
};

export default EmployeeList;
